<template>
  <el-menu
    mode="horizontal"
    :show-timeout="200"
    :default-active="$route.path"
    background-color="#304156"
    text-color="#bfcbd9"
    active-text-color="#409EFF"
    class="bottom-sidebar"
  >
    <div class="menu-wrapper" >
      <template v-for="item in routes" v-if="!item.hidden && item.children">

        <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children && !item.alwaysShow"
                     :to="item.path + '/' + item.children[0].path" :key="item.children[0].name">
          <el-menu-item :index="item.path + '/' + item.children[0].path" >
            <div style="display: flex;flex-direction: column ;">
              <div>
                <svg-icon v-if="item.children[0].meta && item.children[0].meta.icon"
                          :icon-class="item.children[0].meta.icon" style="height:20px;"
                          class="el-icon-location"></svg-icon>
              </div>
              <div v-if="item.children[0].meta && item.children[0].meta.title"
                   style="width:100%;margin-top:-40px;font-size:10px;text-align: center;margin-left:-2px;">
                <span>{{ $t('menu.' + item.children[0].meta.title) }}</span>
              </div>
            </div>
          </el-menu-item>
        </router-link>

        <el-submenu v-else :index="item.name || item.path" :key="item.name">
          <template slot="title">

            <div style="display: flex;flex-direction: column ;">
              <div style="margin-top:-10px;text-align: center;">
                <svg-icon v-if="item.meta && item.meta.icon"
                          :icon-class="item.meta.icon" style="height:16px;"
                          class="el-icon-location"></svg-icon>
              </div>
              <div v-if="item.meta && item.meta.title"
                   style="width:100%;margin-top:-37px;font-size:10px;display: flex;justify-content:center;">
                <span>{{ $t('menu.' + item.meta.title) }}</span>
              </div>
            </div>
<!--            <svg-icon v-if="item.meta && item.meta.icon" :icon-class="item.meta.icon"></svg-icon>-->
<!--            <span v-if="item.meta && item.meta.title">{{ $t('menu.' + item.meta.title) }}</span>-->
          </template>

          <template v-for="child in item.children" v-if="!child.hidden">
            <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children && child.children.length > 0"
                          :routes="[child]" :key="child.path"></sidebar-item>
            <!--支持外链功能-->
            <a v-else-if="child.path.startsWith('http')" v-bind:href="child.path" target="_blank" :key="child.name">
              <el-menu-item :index="item.path + '/' + child.path">
                <svg-icon v-if="child.meta && child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
                <span v-if="child.meta && child.meta.title">{{ $t('menu.' + child.meta.title) }}</span>
              </el-menu-item>
            </a>
            <router-link v-else :to="item.path + '/' + child.path" :key="child.name">
              <el-menu-item :index="item.path + '/' + child.path">
                <svg-icon v-if="child.meta && child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
                <span v-if="child.meta && child.meta.title">{{ $t('menu.' + child.meta.title) }}</span>
              </el-menu-item>
            </router-link>
          </template>
        </el-submenu>

      </template>
    </div>
  </el-menu>
</template>

<script>

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.bottom-sidebar {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #304156;
}


.menu-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: #304156;
}

.el-menu-item {
  display: flex; /* 使用flex布局 */
  flex-direction: column; /* 子元素垂直排列 */
  align-items: center; /* 子元素水平居中 */
  justify-content: center; /* 子元素垂直居中 */
}

</style>



// WEBPACK FOOTER //
// src/views/layout/components/BottomSidebar/SidebarItem.vue